import * as React from "react";

import Card from '@mui/material/Card';
import { useEffect, useState } from 'react';
import Box from "@mui/material/Box";
import axios from "axios";
import { MapContainer, TileLayer, Marker, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css'
// Realtor16 RapidAPI credentials
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import {  Grid, Link, InputLabel, Select, MenuItem, FormControl } from "@mui/material";
import {
    Unstable_NumberInput as BaseNumberInput,
    NumberInputProps,
  } from '@mui/base/Unstable_NumberInput';
import { styled } from '@mui/system';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import HomeWorkIcon     from '@mui/icons-material/HomeWork';
import PaymentIcon      from '@mui/icons-material/Payment';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import AddHomeIcon from '@mui/icons-material/AddHome';
import HouseIcon from '@mui/icons-material/House';
import StraightenIcon from '@mui/icons-material/Straighten';
import SquareFootIcon from '@mui/icons-material/SquareFoot';
import Chip from '@mui/material/Chip';
import Button from '@mui/material/Button';
import BedIcon from '@mui/icons-material/Bed';
import EmailIcon from '@mui/icons-material/Email';
import BusinessIcon from '@mui/icons-material/Business';
import BathtubIcon from '@mui/icons-material/Bathtub';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid
} from 'recharts';
import L from 'leaflet';
import CircularProgress from '@mui/material/CircularProgress';
import Avatar from '@mui/material/Avatar';
import { OpenAI } from 'openai';
const openai = new OpenAI({
  apiKey: process.env.REACT_APP_OPENAI_KEY,
  dangerouslyAllowBrowser: true,
});
 const OfferModal = ({ listing: initialListing = {}, onClose }) => {
     // hold the listing in state so we can swap it
     const [listing, setListing] = useState(initialListing);
     // — Anthony Ai state —
// — Anthony Ai state —
 const [anthonyAsked, setAnthonyAsked] = useState(false);
 const [jamesAsked, setJamesAsked]     = useState(false);

 const [anthonyLoading, setAnthonyLoading] = useState(false);
 const [jamesLoading, setJamesLoading]     = useState(false);

 const [anthonyText, setAnthonyText] = useState('');
 const [jamesText, setJamesText]     = useState('');
const [anthonyVerdict, setAnthonyVerdict] = useState(null);
const [jamesVerdict, setJamesVerdict] = useState(null);
 const [anthonyError, setAnthonyError] = useState('');
 const [jamesError, setJamesError]     = useState('');
     // reset when parent listing changes
// reset when parent listing changes
useEffect(() => {
  setListing(initialListing);
  setPurchasePrice(initialListing.price ?? initialListing.zestimate ?? 0);
  setPhotoIdx(0);

  setAnthonyText(''); 
  setAnthonyError(''); 
  setAnthonyLoading(false);

  setJamesText('');
  setJamesError('');  
  setJamesLoading(false);

  // NEW resets
  setAnthonyVerdict(null);
  setJamesVerdict(null);
  setAnthonyAsked(false);
  setJamesAsked(false);
}, [initialListing]);
    // avoid undefined errors
    const {
      listingAgent = {},
      listingOffice = {}
    } = listing;
        // street-view fallback (you already have this)
    
        // ◼︎ new: photos slider state
        const [photos,    setPhotos]    = useState([]);
        const [photoIdx,  setPhotoIdx]  = useState(0);       
         const [photoIndex, setPhotoIndex] = useState(0);    const [monthlyMaintainenceReservation, setMonthlyMaintainenceReservation] = useState(0);
    const [monthlyVacancyReserve, setMonthlyVacancyReserve] = useState(0);
    const [monthlyUtilities, setMonthlyUtilities] = useState(0);
    const [iconsActive, setIconsActive] = useState('pill1');
    const [downPayment, setDownPayment] = useState(0);
    const [downPaymentPercentage, setDownPaymentPercentage] = useState(0);
    const [closingCostsPercentage, setClosingCostsPercentage] = useState(0);
    const [interestRate, setInterestRate] = useState(0);
    const [term, setTerm] = useState(0);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [history, setHistory] = useState([]);
const [taxHistory, setTaxHistory] = useState([]);
    const [descriptionText, setDescriptionText] = useState("");
    const [details, setDetails] = useState(null);
    const [similarSales, setSimilarSales] = useState([]);
    const [detailsLoaded, setDetailsLoaded] = useState(false);
const [imagesLoaded, setImagesLoaded] = useState(false);
const [similarProperties, setSimilarProperties] = useState([]);
const [photosLoaded, setPhotosLoaded] = useState(false);
const [readyForZillow, setReadyForZillow] = useState(false);    const [zillowImages, setZillowImages] = useState([]);
    const {
      zpid,
      streetAddress,
      city,
      state,
      zipcode,
      description: zillowDescription,
      price: zillowPrice,
      zestimate,
      rentZestimate,
      livingAreaValue: zillowSqft,
      livingAreaUnits,
      yearBuilt: zillowYearBuilt,
      bedrooms: zillowBedrooms,
      bathrooms: zillowBathrooms,
      homeType,
      timeOnZillow,
    } = listing;

    const {
      homeStatus,            // e.g. "SOLD", "OTHER", "FOR_SALE", "FOR_RENT", etc.
      listingSubType = {}    // { is_comingSoon, is_pending, is_forAuction, is_bankOwned, is_FSBA, ... }
    } = listing
  // Log once whenever `listing` updates
  useEffect(() => {
    console.log("🛈 OfferModal listing updated:", listing);
  }, [listing]);

useEffect(() => {
  if (!listing.property_id) return;

  let cancelled = false;
  const delay = ms => new Promise(res => setTimeout(res, ms));

  (async () => {
    try {
      // 1) DETAILS (immediate)
      const detailsResp = await axios.get(
        "https://realtor16.p.rapidapi.com/property/details",
        {
          params: { property_id: listing.property_id },
          headers: {
            "x-rapidapi-host": RAPIDAPI_HOST,
            "x-rapidapi-key": RAPIDAPI_KEY,
          },
        }
      );
      if (cancelled) return;
      setDetails(detailsResp.data.data);

      // 2) HISTORY (after 600ms)
// 3) PHOTOS (after another 600ms), with retry-on-429
await delay(600);

const fetchPhotos = async () => {
  try {
    const photosResp = await axios.get(
      "https://realtor16.p.rapidapi.com/property/photos",
      {
        params: { property_id: listing.property_id },
        headers: {
          "x-rapidapi-host": RAPIDAPI_HOST,
          "x-rapidapi-key": RAPIDAPI_KEY,
        },
      }
    );
    if (cancelled) return;
    setPhotos(photosResp.data.map(img => img.href));
  } catch (err) {
    if (err.response?.status === 429) {
      console.warn("Rate limited fetching photos; retrying in 1s…");
      await delay(1000);
      const retry = await axios.get(
        "https://realtor16.p.rapidapi.com/property/photos",
        {
          params: { property_id: listing.property_id },
          headers: {
            "x-rapidapi-host": RAPIDAPI_HOST,
            "x-rapidapi-key": RAPIDAPI_KEY,
          },
        }
      );
      if (cancelled) return;
      setPhotos(retry.data.map(img => img.href));
    } else {
      console.error("Error loading MLS photos:", err);
    }
  }
};

await fetchPhotos();

    } catch (err) {
      console.error("Realtor API error:", err);
    }
  })();

  return () => { cancelled = true; };
}, [listing.property_id]);




















    let marketStatus = "Unknown"
    if (homeStatus === "SOLD") {
      marketStatus = "Sold"
    } else if (listingSubType.is_forRent || homeStatus === "FOR_RENT") {
      marketStatus = "For Rent"
    } else if (listingSubType.is_forSale || homeStatus === "FOR_SALE") {
      marketStatus = "For Sale"
    } else if (listingSubType.is_comingSoon) {
      marketStatus = "Coming Soon"
    } else if (listingSubType.is_pending) {
      marketStatus = "Pending"
    } else if (homeStatus === "OTHER") {
      marketStatus = "Off Market"
    }
    const [currentListing, setCurrentListing] = useState(listing);

// if the parent’s listing prop changes, pick that up
useEffect(() => {
  setCurrentListing(listing);
  setPhotoIdx(0);
}, [listing]);
useEffect(() => {
  setPurchasePrice(listing.price ?? listing.zestimate ?? null);
}, [listing]);

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl:
    'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl:
    'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

// custom blue‐dot + price label
function createMarkerIcon(home) {
  const labelText = home.price != null
    ? `$${home.price.toLocaleString()}`
    : '–';

  return L.divIcon({
    className: '',
    html: `
      <div style="text-align:center; font-size:12px; font-weight:bold; position:relative;">
        <div style="
          background:#fff;
          padding:4px 8px;           /* ← wider padding */
          min-width:60px;            /* ← enforce min width */
          border-radius:4px;         /* slightly larger rounding */
          box-shadow:0 1px 2px rgba(0,0,0,0.15);
          transform:translateY(-16px);
          white-space:nowrap;
          overflow:hidden;
          text-overflow:ellipsis;
        ">${labelText}</div>
        <div style="
          width:12px;
          height:12px;
          background:#007aff;
          border:2px solid #fff;
          border-radius:50%;
          box-shadow:0 1px 2px rgba(0,0,0,0.2);
          transform:translateY(-6px);
          margin:0 auto;
        "></div>
      </div>
    `,
    iconSize:   [40, 40],
    iconAnchor: [20, 40],
  });
}

// when a nearby card is clicked, look up that address and swap in the new listing
  // when a nearby-home card is clicked, look it up and swap in the new listing
  const handleNearbySelect = async (home) => {
    const addr = `${home.address.streetAddress}, ${home.address.city}, ${home.address.state} ${home.address.zipcode}`;
    try {
      const { data } = await axios.get(
        'https://zillow-com1.p.rapidapi.com/property',
        {
          params: { address: addr },
          headers: {
            'x-rapidapi-host': 'zillow-com1.p.rapidapi.com',
            'x-rapidapi-key':RAPIDAPI_KEY
          }
        }
      );
      setListing(data);
      setZillowImages([]);
      setPhotoIdx(0);
    } catch (err) {
      console.error('Failed loading nearby property:', err);
    }
  };
  
// simple cashflow for AI: FMR - mortgage (monthly)


// re-ask when listing changes or key numbers change

  
    // ─── 3) COMPUTE FLAGS + FALLBACKS ─────────────────────────────
    // ← ADD HERE
    const isZillow = Boolean(zpid);
  
    const displayAddress = isZillow
      ? `${streetAddress}, ${city}, ${state} ${zipcode}`
      : listing.formattedAddress;
  
    const displayPrice = isZillow ? zillowPrice : listing.price;
 
    

    const yearBuilt      = details?.description?.year_built;
const livingSqFt     = details?.description?.sqft;
const agentData      = details?.advertisers?.find(a => a.type === "seller");
const officeData     = agentData?.office;
const agentName      = agentData?.name;
const agentPhone     = agentData?.phones?.[0]?.number;
const agentEmail     = agentData?.email;
const officeName     = officeData?.name;
const officePhone    = officeData?.phones?.[0]?.number;
const officeEmail    = officeData?.email;
useEffect(() => {
  if (!listing.property_id) return;
  axios
    .get("https://realtor16.p.rapidapi.com/property/details", {
      params: { property_id: listing.property_id },
      headers: {
        "x-rapidapi-host": RAPIDAPI_HOST,
        "x-rapidapi-key": RAPIDAPI_KEY,
      },
    })
    .then(res => {
      const text = res.data.data.description?.text;
      if (typeof text === "string") setDescriptionText(text);
    })
    .catch(err => console.error("Error loading MLS details:", err));
}, [listing.property_id]);
    const RAPIDAPI_HOST = "realtor16.p.rapidapi.com";
    const RAPIDAPI_KEY  = "510e42edf9msh1028fbc335ec8e9p12456ejsn237f189ede04";
    const [purchasePrice, setPurchasePrice] = useState(
      initialListing.price ?? initialListing.zestimate ?? 0
    );    const handleIconsClick = (value) => {
      if (value === iconsActive) {
        return;
      }
  
      setIconsActive(value);
    };
    let  OneBedFMR = 1207  // let OneBedFMR = 1
    let TwoBedFMR = 1355 // let OneBedFMR = 1
    let ThreeBedFMR = 1781  // let OneBedFMR = 1
    let FourBedFMR = 2086  // let OneBedFMR = 1
    let EfficiencyFMR = 1105  // let OneBedFMR = 1
   
    let fmr = 0
  



    const splitAddress = (address) => {
      const addressStr = String(address);
      const regex = /^(.*?),\s*(.*)$/;
      const match = addressStr.match(regex);
  
      return match ? { address1: match[1], address2: match[2] } : null;
    };
  
useEffect(() => {
  if (!listing.property_id) return;
  const timer = setTimeout(async () => {
    try {
      const res = await axios.get(
        "https://realtor16.p.rapidapi.com/property/history",
        {
          params: { property_id: listing.property_id },
          headers: { "x-rapidapi-host": RAPIDAPI_HOST, "x-rapidapi-key": RAPIDAPI_KEY },
        }
      );
      if (res.status === 429) {
        // retry once after 1s
        setTimeout(async () => {
          const retry = await axios.get(res.config.url, { headers: res.config.headers });
          setHistory(retry.data.home.property_history || []);
          setTaxHistory(retry.data.home.tax_history       || []);
        }, 1000);
      } else {
        setHistory(res.data.home.property_history || []);
        setTaxHistory(res.data.home.tax_history       || []);
      }
    } catch (err) {
      console.error("History fetch failed:", err);
    }
  }, 2000);
  return () => clearTimeout(timer);
}, [listing.property_id]);
    // const fetchPropertyData = async (address1, address2) => {
    //   const url =
    //     "https://api.gateway.attomdata.com/propertyapi/v1.0.0/property/basicprofile";
    //   const params = new URLSearchParams({ address1, address2 });
  
    //   setLoading(true);
    //   setError(null);
  
    //   try {
    //     const response = await fetch(`${url}?${params.toString()}`, {
    //       headers: {
    //         Accept: "application/json",
    //         APIKey: "b38c60f63ce05ed8f003d2388313f574", // Replace with actual API key
    //       },
    //     });
  
    //     if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
  
    //     const data = await response.json();
  
    //     // Extract FIPS and APN
    //     if (data.property && data.property.length > 0) {
    //       const fips = data.property[0].identifier.fips;
    //       const apn = data.property[0].identifier.apn.replace(/\D/g, ""); // Remove non-numeric chars
  
    //       // Redirect to Zillow link
    //       window.location.href = `https://www.zillow.com/CountyAssessorPage.htm?COUNTY_ID=${fips}&FORCE_GENERIC=false&LINK_LOCATION=TaxHistory&PARCEL_NUM=${apn}`;
    //     } else {
    //       throw new Error("Property data not found.");
    //     }
    //   } catch (err) {
    //     setError(err.message);
    //   } finally {
    //     setLoading(false);
    //   }
    // };
  
    // const handleButtonClick = () => {
    //   const addressParts = splitAddress(listing.formattedAddress);
    //   if (!addressParts) {
    //     setError("Invalid address format");
    //     return;
    //   }
    //   fetchPropertyData(addressParts.address1, addressParts.address2);
    // };


    const pillContainer = {
        
        
            gap: '20px 10px',
            marginTop: '35px',
            width: '100%',

            
            alignItems: 'center'
    }
    const pillContainer3 = {
        
        
            gap: '20px 10px',
            marginTop: '35px',
            width: '100%',

            
            alignItems: 'center'
    }
    const pillContainer2 = {
        
        
            gap: '20px 10px',
            marginTop: '35px',
            width: '100%',

            
            alignItems: 'center'
    }
    const data = [
        { label: "Tab 1", bgcolor: "#ffcccb" },
        { label: "Tab 2", bgcolor: "#b0e57c" },
        { label: "Tab 3", bgcolor: "#87ceeb", icon: "📌" },
      ];
    
    if (listing.bedrooms === 1) {
  fmr  = OneBedFMR
  
  }
    if (listing.bedrooms === 2) {
  fmr  = TwoBedFMR
  
  }
    if (listing.bedrooms === 3) {
  fmr  = ThreeBedFMR
  
  }
    if (listing.bedrooms > 3) {
  fmr  = FourBedFMR
  
  }

  var M; //monthly mortgage payment
    var P = (purchasePrice * .8); //principle / initial amount borrowed
    var I = 6.5 / 100 / 12; //monthly interest rate
    var N = 30 * 12; //number of payments months  

    function monthlyPayment(p, n, i) {
      return p * i * (Math.pow(1 + i, n)) / (Math.pow(1 + i, n) - 1);
    }

    M = monthlyPayment(P, N, I);
    

  var calculatedM; //monthly mortgage payment
    var calculatedP = (purchasePrice * (1-(downPaymentPercentage*.01))); //principle / initial amount borrowed
    var calculatedI = interestRate / 100 / 12; //monthly interest rate
    var calculatedN = term * 12; //number of payments months  

    function calculatedMonthlyPayment(calculatedp, calculatedn, calculatedi) {
      return calculatedp * calculatedi * (Math.pow(1 + calculatedi, calculatedn)) / (Math.pow(1 + calculatedi, calculatedn) - 1);
    }

    calculatedM = Math.round(calculatedMonthlyPayment(calculatedP, calculatedN, calculatedI));
    function FitBounds({ homes }) {
      const map = useMap();
      const bounds = homes.map(h => [h.latitude, h.longitude]);
      if (bounds.length) map.fitBounds(bounds, { padding: [40, 40] });
      return null;
    }
const StyledInputRoot = styled('div')(
    ({ theme }) => `
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 400;
    color: ${theme.palette.mode === 'dark' ? grey[300] : grey[500]};
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
  `,
  );
  
  const StyledInput = styled('input')(
    ({ theme }) => `
    font-size: 0.875rem;
    font-family: inherit;
    font-weight: 400;
    line-height: 1.375;
    color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
    background: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
    border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
    box-shadow: 0 2px 4px ${
      theme.palette.mode === 'dark' ? 'rgba(0,0,0, 0.5)' : 'rgba(0,0,0, 0.05)'
    };
    border-radius: 8px;
    margin: 0 8px;
    padding: 10px 12px;
    outline: 0;
    min-width: 0;
    width: 4rem;
    text-align: center;
  
    &:hover {
      border-color: ${blue[400]};
    }
  
    &:focus {
      border-color: ${blue[400]};
      box-shadow: 0 0 0 3px ${theme.palette.mode === 'dark' ? blue[700] : blue[200]};
    }
  
    &:focus-visible {
      outline: 0;
    }
  `,
  );
  
  
  
  const StyledButton = styled('button')(
    ({ theme }) => `
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 0.875rem;
    box-sizing: border-box;
    line-height: 1.5;
    border: 1px solid;
    border-radius: 999px;
    border-color: ${theme.palette.mode === 'dark' ? grey[800] : grey[200]};
    background: ${theme.palette.mode === 'dark' ? grey[900] : grey[50]};
    color: ${theme.palette.mode === 'dark' ? grey[200] : grey[900]};
    width: 32px;
    height: 32px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 120ms;
  
    &:hover {
      cursor: pointer;
      background: ${theme.palette.mode === 'dark' ? blue[700] : blue[500]};
      border-color: ${theme.palette.mode === 'dark' ? blue[500] : blue[400]};
      color: ${grey[50]};
    }
  
    &:focus-visible {
      outline: 0;
    }
  
    &.increment {
      order: 1;
    }
  `,
  );

    console.log(listing)

    let propertyTaxOperatingCost = Math.round(purchasePrice * .000925)
  let insuranceOperatingCost = Math.round(purchasePrice * .000833)


  ///////////PROPERTY TAXES///////////////////

/////////////PROPERTY MANAGEMENT//////////


// const totalPropManagement = currentRent *.1
const potentialTotalPropManagement = fmr *.1


//   let totalMonthlyExpense = (totalPropManagement+propertyTaxOperatingCost+insuranceOperatingCost+monthlyUtilities+monthlyVacancyReserve+monthlyMaintainenceReservation+Math.round(monthlyPayment(P,N,I)))
   let potentialTotalMonthlyExpense = (potentialTotalPropManagement+propertyTaxOperatingCost+insuranceOperatingCost+monthlyUtilities+monthlyVacancyReserve+monthlyMaintainenceReservation+Math.round(monthlyPayment(P,N,I)))
const NumberInput = React.forwardRef(function CustomNumberInput(
    props,ref
  ) {
    return (
      <BaseNumberInput
        slots={{
          root: StyledInputRoot,
          input: StyledInput,
          incrementButton: StyledButton,
          decrementButton: StyledButton,
        }}
        slotProps={{
          incrementButton: {
            children: <AddIcon fontSize="small" />,
            className: 'increment',
          },
          decrementButton: {
            children: <RemoveIcon fontSize="small" />,
          },
        }}
        {...props}
        ref={ref}
      />
    );
  });

  const blue = {
    100: '#daecff',
    200: '#b6daff',
    300: '#66b2ff',
    400: '#3399ff',
    500: '#007fff',
    600: '#0072e5',
    700: '#0059B2',
    800: '#004c99',
  };
  
  const grey = {
    50: '#F3F6F9',
    100: '#E5EAF2',
    200: '#DAE2ED',
    300: '#C7D0DD',
    400: '#B0B8C4',
    500: '#9DA8B7',
    600: '#6B7A90',
    700: '#434D5B',
    800: '#303740',
    900: '#1C2025',
  };
  
  const handleOverlayClick = (e) => {
    // Check if the click target is the overlay (not the modal content itself)
    if (e.target.className === "modal-overlay") {
      onClose();
    }
  };

  const overlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 999,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };
  
// inside OfferModal, after your nearbyHomes cards effect:



  
    useEffect(() => {
      // wait for the MLS property_id to exist
      if (!listing.property_id) return;
    
      const loadPhotos = async () => {
        try {
          const { data } = await axios.get(
            "https://realtor16.p.rapidapi.com/property/photos",
            {
              params: { property_id: listing.property_id },
              headers: {
                "x-rapidapi-host": RAPIDAPI_HOST,
                "x-rapidapi-key":  RAPIDAPI_KEY,
              },
            }
          );
    
          // pull out just the URLs
          const urls = data.map(img => img.href);
          setPhotos(urls);
          setPhotoIndex(0);
    
        } catch (err) {
          console.error("Error loading MLS photos:", err);
        }
      };
    
      loadPhotos();
    }, [listing.property_id]);

    const bannerImages = zillowImages.length ? zillowImages : photos;

const aiCashflow = Number.isFinite(fmr) && Number.isFinite(M)
  ? Math.round(fmr - Math.round(M))
  : null;

// verdict helper based on monthly cashflow
// inputs check
const hasInputs = Number.isFinite(fmr) && Number.isFinite(M);

// NEW monthly cashflow formula: FMR − Mortgage − 10% mgmt
const cashflowMonthly = hasInputs
  ? Math.round(fmr - M - fmr * 0.1)
  : null;

function verdictFromCashflow(cf) {
  if (!Number.isFinite(cf)) return { label: '—', color: 'default' };
  if (cf <= 0)               return { label: 'Bad deal',  color: 'error'   };
  if (cf <= 300)             return { label: 'OK deal',   color: 'warning' };
  if (cf <= 499)             return { label: 'Good deal', color: 'success' };
  return                       { label: 'Great deal',     color: 'success' };
}
const verdict = verdictFromCashflow(aiCashflow);


// Anthony
// Anthony
const askAnthony = async () => {
  if (!hasInputs) return;
  setAnthonyAsked(true);
  setAnthonyLoading(true);
  setAnthonyError('');
  setAnthonyText('');

  try {
    const price = purchasePrice || listing.price || 0;
    const beds  = listing.bedrooms ?? zillowBedrooms ?? '—';
    const baths = listing.bathrooms ?? zillowBathrooms ?? '—';

    const system = `
You are "Anthony Ai", a seasoned buy-and-hold real estate investor.
Speak informally but professionally. Give a quick gut-check opinion in ONE short paragraph (2–5 sentences).
ONLY return the paragraph wrapped in double quotes. Do not add any headers or extra lines.
Consider cashflow as: FMR − Mortgage − 10% management. Mention if cashflow is positive/negative and why.
Avoid any legal/financial disclaimers.
`.trim();

    const user = `
Address: ${displayAddress}
Price: $${Number(price).toLocaleString()}
Beds/Baths: ${beds} / ${baths}
FMR (monthly): $${Number.isFinite(fmr) ? Math.round(fmr).toLocaleString() : 'n/a'}
Mortgage (monthly): $${Number.isFinite(M) ? Math.round(M).toLocaleString() : 'n/a'}
Mgmt (10% of FMR): $${Number.isFinite(fmr) ? Math.round(fmr * 0.1).toLocaleString() : 'n/a'}
Cashflow (FMR − Mortgage − 10% mgmt): ${Number.isFinite(cashflowMonthly) ? `$${cashflowMonthly.toLocaleString()}` : 'n/a'}

Write a single-paragraph quote from "Anthony Ai" about whether this is a promising rental based on the cashflow and basic buy/hold heuristics (vacancy, taxes, capex may exist—do NOT recompute numbers, just note risks). Keep it concise and actionable. Return ONLY the paragraph in double quotes.
`.trim();

    const resp = await openai.chat.completions.create({
      model: 'gpt-4o-mini',
      temperature: 0.5,
      messages: [
        { role: 'system', content: system },
        { role: 'user',   content: user }
      ],
    });

    const content = resp?.choices?.[0]?.message?.content?.trim() || '';
const clean = content.replace(/\n+/g, ' ').trim();
setAnthonyText(clean);
setAnthonyVerdict(parseVerdictWithFallback(clean, cashflowMonthly));
  } catch (e) {
    setAnthonyError(e?.message || 'Failed to fetch Anthony Ai.');
  } finally {
    setAnthonyLoading(false);
  }
};

// James
// James
const askJames = async () => {
  if (!hasInputs) return;
  setJamesAsked(true);
  setJamesLoading(true);
  setJamesError('');
  setJamesText('');

  try {
    const price = purchasePrice || listing.price || 0;
    const beds  = listing.bedrooms ?? zillowBedrooms ?? '—';
    const baths = listing.bathrooms ?? zillowBathrooms ?? '—';

    const system = `
You are "James Ai": a blunt, street-smart real estate investor with sharp, profane swagger (including f words, shit, and mild racism).
STYLE: punchy, funny, aggressive *roast* vibe — If deal is really bad, roast the user
DECISION RULES (follow in order):
1) PRIORITIZE MONTHLY CASHFLOW above all else (FMR − Mortgage − 10% mgmt). React to that number first.
2) Only use price, beds/baths, and other details as SECONDARY context *insofar as they affect cashflow or risk*.
3) If cashflow is positive but fragile, call it borderline/OK and mention the thin margin. If strongly positive, hype it.
4) If cashflow is negative, call it a bad deal, full stop.

OUTPUT:
- One short paragraph (2–5 sentences) in double quotes only.
`.trim();

    const user = `
Address: ${displayAddress}
Price: $${Number(price).toLocaleString()}
Beds/Baths: ${beds} / ${baths}
FMR (monthly): $${Number.isFinite(fmr) ? Math.round(fmr).toLocaleString() : 'n/a'}
Mortgage (monthly): $${Number.isFinite(M) ? Math.round(M).toLocaleString() : 'n/a'}
Mgmt (10% of FMR): $${Number.isFinite(fmr) ? Math.round(fmr * 0.1).toLocaleString() : 'n/a'}
Monthly cashflow (FMR − Mortgage − 10% mgmt): ${Number.isFinite(cashflowMonthly) ? `$${cashflowMonthly.toLocaleString()}` : 'n/a'}

React to the CASHFLOW number first. If you mention risks, tie them back to how they'd hit cashflow.
`.trim();

    const resp = await openai.chat.completions.create({
      model: 'gpt-4o-mini',
      temperature: 0.6,
      messages: [
        { role: 'system', content: system },
        { role: 'user',   content: user },
      ],
    });

    const content = resp?.choices?.[0]?.message?.content?.trim() || '';
    const clean = content.replace(/\n+/g, ' ').trim();
    setJamesText(clean);
    setJamesVerdict(parseVerdictWithFallback(clean, cashflowMonthly));
  } catch (e) {
    setJamesError(e?.message || 'Failed to fetch James Ai.');
  } finally {
    setJamesLoading(false);
  }
};
function parseVerdictWithFallback(text, cf) {
  if (!text) return verdictFromCashflow(cf);
  const t = text.toLowerCase();

  // quick “not … good/great” guards
  const neg = (s) => t.includes(`not ${s}`) || t.includes(`isn't ${s}`) || t.includes(`ain't ${s}`);

  // very negative
  if (/\bdumpster fire\b|\btrash\b|\brun away\b|\brun the other way\b|\bterrible\b|\bawful\b|\bhorrible\b/.test(t)) {
    return { label: 'Bad deal', color: 'error' };
  }
  if (t.includes('bad deal') || t.includes('money pit') || t.includes('garbage') || t.includes('nope')) {
    return { label: 'Bad deal', color: 'error' };
  }

  // great / good / ok — watch for negations
  if (!neg('great') && (t.includes('great deal') || t.includes('slam dunk') || t.includes('amazing') || t.includes('home run') || t.includes('banger'))) {
    return { label: 'Great deal', color: 'success' };
  }
  if (!neg('good') && (t.includes('good deal') || t.includes('solid deal') || t.includes('pretty good') || t.includes('looks good'))) {
    return { label: 'Good deal', color: 'success' };
  }
  if (t.includes('ok deal') || t.includes('okay deal') || t.includes('meh') || t.includes('so-so') || t.includes('borderline')) {
    return { label: 'OK deal', color: 'warning' };
  }

  // fallback to numeric cashflow thresholds
  return verdictFromCashflow(cf);
}

const ANTHONY_IMG = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR_9OAjkD0zVtyjYoWFCJ8dZZ4L6K51rlI1ew&s";
const JAMES_IMG   = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTKs9TUOnmzwFYvybYYAkKQIFNYSfBaGTvRzXRdiC__RB1sLYxEEu4QC3Z_OvupoPPsSAA&usqp=CAU";
    return (
          <div
            className="modal-overlay"
            onClick={handleOverlayClick}
            style={overlayStyle}
          >
            {/* Card is now the modal itself */}
            <Card
              sx={{
                position: 'fixed',
                top: '55%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 1030,
                maxHeight: '90vh',
                   overflowY: 'auto',    // allow vertical scrolling
                   overflowX: 'hidden',  // still clip any horizontal bleed
                   borderRadius: '20px',   // clip image to rounded corners
                p: 0,
                boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
                bgcolor: '#fff',
                zIndex: 1000
              }}
            >
             



              <div
            style={{
              position: 'relative',
              width: '100%',
              height: 500,
              backgroundColor: '#fff'   
            }}
           >
                        {/* ← now the close-“X” lives on top of the image */}
            <button
              onClick={onClose}
              style={{
                position: 'absolute',
                top: 8,
                right: 8,
                background: 'rgba(0,0,0,0.5)',
                color: '#fff',
                border: 'none',
                borderRadius: '50%',
                width: 32,
                height: 32,
                cursor: 'pointer',
                zIndex: 20
              }}
            >×</button>

<img
              src={bannerImages[photoIdx]}
              alt={`Photo ${photoIdx + 1}`}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain',       
                objectPosition: 'center',    
                backgroundColor: '#fff'      

              }}
            />
  {/* ← LEFT ARROW */}
 <button
   onClick={() => setPhotoIdx(prev => Math.max(prev - 1, 0))}
   disabled={photoIdx === 0}
   style={{
     position: 'absolute', left: 0, top: '50%',
     transform: 'translateY(-50%)',
     background: 'rgba(0,0,0,0.5)', color: '#fff',
     border: 'none', padding: '8px', cursor: 'pointer',
     zIndex: 10
   }}
 >◀</button>

 {/* ← RIGHT ARROW */}
 <button
   onClick={() => setPhotoIdx(prev => Math.min(prev + 1, bannerImages.length - 1))}
   disabled={photoIdx === bannerImages.length - 1}
   style={{
     position: 'absolute', right: 0, top: '50%',
     transform: 'translateY(-50%)',
     background: 'rgba(0,0,0,0.5)', color: '#fff',
     border: 'none', padding: '8px', cursor: 'pointer',
     zIndex: 10
   }}
 >▶</button>
</div>
{/* — AI Panel — */}
{/* — AI Panel — */}
{/* — AI Panel — */}
<Box
  sx={{
    mx: 2, mt: 2, mb: 1,
    p: 2,
    borderRadius: 2,
    bgcolor: '#fff',               // white background
    border: '1px solid #eee',
    boxShadow: '0 6px 16px rgba(0,0,0,0.08)', // floating feel
  }}
>
  {/* Header row: avatars + buttons (buttons disappear once clicked) */}
  <Box sx={{ display:'flex', alignItems:'center', justifyContent:'space-between', flexWrap:'wrap', gap: 1 }}>
    <Box sx={{ display:'flex', alignItems:'center', gap: 2 }}>
      <Box sx={{ display:'flex', alignItems:'center', gap: 1 }}>
        <Avatar src={ANTHONY_IMG} alt="Anthony" sx={{ width: 34, height: 34 }} />
        <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>Anthony Ai</Typography>
      </Box>
      {!anthonyAsked && !anthonyLoading && (
        <Button variant="contained" size="small" onClick={askAnthony} disabled={!hasInputs}>
          Ask Anthony
        </Button>
      )}
    </Box>

    <Box sx={{ display:'flex', alignItems:'center', gap: 2 }}>
      {!jamesAsked && !jamesLoading && (
        <Button color="secondary" variant="contained" size="small" onClick={askJames} disabled={!hasInputs}>
          Ask James
        </Button>
      )}
      <Box sx={{ display:'flex', alignItems:'center', gap: 1 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>James Ai</Typography>

        <Avatar src={JAMES_IMG} alt="James" sx={{ width: 34, height: 34 }} />
      </Box>
      
    </Box>
  </Box>

  {/* Answers appear ONLY after click (or while loading) */}
  <Box sx={{ mt: 2, display:'grid', gridTemplateColumns:'1fr 1fr', gap: 2 }}>
    {/* Anthony (avatar left, bubble left-tail) */}
    {/* Anthony (always pinned to the LEFT column) */}
{(anthonyLoading || anthonyText || anthonyError) ? (
  <Box sx={{ gridColumn:'1 / 2', display:'flex', alignItems:'flex-start', gap: 1 }}>
    <Avatar src={ANTHONY_IMG} alt="Anthony" sx={{ width: 40, height: 40, mt: 0.5 }} />
    <Box sx={{ position:'relative', maxWidth:'100%' }}>
      <Box
        sx={{
          position:'relative',
          bgcolor:'#ffffff',
          border:'1px solid #e5ecf6',
          borderRadius: 2,
          p: 1.5,
          boxShadow:'0 1px 3px rgba(0,0,0,0.08)',
        }}
      >
        {anthonyLoading && (
          <Typography variant="body2">
            <CircularProgress size={16} sx={{ mr:1 }} />
            Asking Anthony…
          </Typography>
        )}
        {!anthonyLoading && anthonyError && (
          <Typography variant="body2" color="error">{anthonyError}</Typography>
        )}
        {!anthonyLoading && !anthonyError && anthonyText && (
          <Typography variant="body2" sx={{ color:'#1b2733' }}>{anthonyText}</Typography>
        )}
        {/* tail (left) */}
        <Box
          sx={{
            position:'absolute',
            left: -10,
            top: 12,
            width: 0,
            height: 0,
            borderStyle: 'solid',
            borderWidth: '10px 10px 10px 0',
            borderColor: 'transparent #ffffff transparent transparent',
            filter:'drop-shadow(-1px 0 0 #e5ecf6)'
          }}
        />
      </Box>

      {/* Verdict centered under the bubble */}
{/* Verdict centered under the bubble */}
{!anthonyLoading && !anthonyError && anthonyText && anthonyVerdict && (
  <Box sx={{ mt: 1, textAlign:'center' }}>
    <Chip
      label={`Anthony's Verdict: ${anthonyVerdict.label}`}
      color={anthonyVerdict.color}
      variant="filled"
      size="small"
    />
    <Typography variant="caption" sx={{ display: 'block', mt: 0.75,   fontSize: '0.7rem'  ,color: 'text.secondary' }}>
      Want to set up a meeting about this deal? Set up a call{' '}
      <Link
        href="https://calendly.com/elevaterei/googlemeet?back=1&month=2025-08"
        target="_blank"
        rel="noopener noreferrer"
        underline="hover"
      >
        here
      </Link>.
    </Typography>
  </Box>
)}
    </Box>
  </Box>
) : (
  // Invisible spacer to keep the grid column reserved
  <Box sx={{ gridColumn:'1 / 2' }} />
)}

    {/* James (flip: avatar RIGHT, bubble with RIGHT tail) */}
    {/* James (always pinned to the RIGHT column) */}
{(jamesLoading || jamesText || jamesError) ? (
  <Box sx={{ gridColumn:'2 / 3', display:'flex', alignItems:'flex-start', gap: 1, justifyContent:'flex-end' }}>
    <Box sx={{ position:'relative', maxWidth:'100%' }}>
      <Box
        sx={{
          position:'relative',
          bgcolor:'#ffffff',
          border:'1px solid #e5ecf6',
          borderRadius: 2,
          p: 1.5,
          boxShadow:'0 1px 3px rgba(0,0,0,0.08)',
        }}
      >
        {jamesLoading && (
          <Typography variant="body2" sx={{ textAlign:'right' }}>
            <CircularProgress size={16} sx={{ mr:1, verticalAlign:'middle' }} />
            Asking James…
          </Typography>
        )}
        {!jamesLoading && jamesError && (
          <Typography variant="body2" color="error" sx={{ textAlign:'right' }}>{jamesError}</Typography>
        )}
        {!jamesLoading && !jamesError && jamesText && (
          <Typography variant="body2" sx={{ color:'#1b2733', textAlign:'right' }}>{jamesText}</Typography>
        )}
        {/* tail (right) */}
        <Box
          sx={{
            position:'absolute',
            right: -10,
            top: 12,
            width: 0,
            height: 0,
            borderStyle: 'solid',
            borderWidth: '10px 0 10px 10px',
            borderColor: 'transparent transparent transparent #ffffff',
            filter:'drop-shadow(1px 0 0 #e5ecf6)'
          }}
        />
      </Box>

      {/* Verdict centered under the bubble */}
      
{/* James verdict */}
{/* James verdict */}
{/* James verdict */}
{!jamesLoading && !jamesError && jamesText && jamesVerdict && (
  <Box sx={{ mt: 1, textAlign:'center' }}>
    <Chip
      label={`James' Verdict: ${jamesVerdict.label}`}
      color={jamesVerdict.color}
      variant="filled"
      size="small"
    />
    <Typography variant="caption" sx={{ display: 'block', mt: 0.75,     fontSize: '0.7rem'   // 👈 smaller than default caption
, color: 'text.secondary' }}>
      Want to set up a meeting about this deal? Set up a call{' '}
      <Link
        href="https://calendly.com/elevaterei/googlemeet?back=1&month=2025-08"
        target="_blank"
        rel="noopener noreferrer"
        underline="hover"
      >
        here
      </Link>.
    </Typography>
  </Box>
)}
    </Box>

    {/* Avatar on the RIGHT */}
    <Avatar src={JAMES_IMG} alt="James" sx={{ width: 40, height: 40, mt: 0.5 }} />
  </Box>
) : (
  // Invisible spacer to keep the grid column reserved
  <Box sx={{ gridColumn:'2 / 3' }} />
)}
  </Box>
</Box>
<Box sx={{ p: 2, textAlign: 'center' }}>
        <Typography variant="h6">{displayAddress}</Typography>
        {isZillow && (
          <>
          <Typography variant="subtitle2" color="textSecondary">
            Listed {timeOnZillow} ago • {homeType?.replace('_', ' ')}
          </Typography>
          <Typography variant="subtitle2" color="textSecondary">
          Status: {marketStatus}
        </Typography>
        </>
        )}
      </Box>


          

  <div className='bg-white'>
          <div className='bg-whites'>
            
            
            
           
          
           <p className="offer__title5">
   {purchasePrice != null
     ? `$${purchasePrice.toLocaleString("en-US")}`
     : "-"}
 </p>
          {isZillow && (
            <Box sx={{
              display: 'flex',
              justifyContent: 'space-around',
              mt: 2,
              mb: 2,
              flexWrap: 'wrap'
            }}>
              <Box sx={{ textAlign: 'center', width: 200 }}>
                <AttachMoneyIcon fontSize="large" />
                <Typography>Sale Price</Typography>
               <Typography variant="h6">
   {purchasePrice != null
     ? `$${purchasePrice.toLocaleString()}`
     : "-"}
 </Typography>              </Box>
 <Box sx={{ textAlign: 'center', width: 200 }}>
  <HomeWorkIcon fontSize="large" />
  <Typography>Elevate Estimate</Typography>
  
   <Typography variant="h6">
   {zestimate != null
     ? `$${zestimate.toLocaleString()}`
     : '–'}
 </Typography>
</Box>
              <Box sx={{ textAlign: 'center', width: 200 }}>
                <PaymentIcon fontSize="large" />
                <Typography>Rent Estimate</Typography>
                <Typography variant="h6">${rentZestimate.toLocaleString()}/mo</Typography>
              </Box>
            </Box>
          )}
           <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-around',
              mt: 4,
              mb: 2,
              flexWrap: 'wrap',
            }}
          >
            <Box sx={{ textAlign: 'center', width: 200 }}>
              <HouseIcon fontSize="large" />
              <Typography>Year Built</Typography>
              <Typography variant="h6">
                {isZillow ? zillowYearBuilt : yearBuilt ?? '—'}
              </Typography>
            </Box>

            <Box sx={{ textAlign: 'center', width: 200 }}>
              <SquareFootIcon fontSize="large" />
              <Typography>SQFT</Typography>
              <Typography variant="h6">
                {isZillow
                  ? `${zillowSqft?.toLocaleString()} ${livingAreaUnits}`
                  : livingSqFt?.toLocaleString() ?? '—'}
              </Typography>
            </Box>

            <Box sx={{ textAlign: 'center', width: 200 }}>
              <BedIcon fontSize="large" />
              <Typography>Bedrooms</Typography>
              <Typography variant="h6">
                {isZillow ? zillowBedrooms : listing.bedrooms ?? '—'}
              </Typography>
            </Box>

            <Box sx={{ textAlign: 'center', width: 200 }}>
              <BathtubIcon fontSize="large" />
              <Typography>Bathrooms</Typography>
              <Typography variant="h6">
                {isZillow ? zillowBathrooms : listing.bathrooms ?? '—'}
              </Typography>
            </Box>
          </Box>

           {!isZillow &&  <Box
  sx={{
    display: 'flex',
    justifyContent: 'space-around',
    mt: 4,
    mb: 2,
    flexWrap: 'wrap'
  }}
>
  {/* Est Cashflow */}
  <Box sx={{ textAlign: 'center', width: 200 }}>
    <AttachMoneyIcon fontSize="large" />
    <Typography>Est Cashflow</Typography>
    <Typography variant="h6">
      {`$${Math.round(fmr - M - fmr * 0.1).toLocaleString('en-US')}`}
    </Typography>
  </Box>

  {/* FMR */}
  <Box sx={{ textAlign: 'center', width: 200 }}>
    <HomeWorkIcon fontSize="large" />
    <Typography>FMR</Typography>
    <Typography variant="h6">
      {`$${Math.round(fmr).toLocaleString('en-US')}`}
    </Typography>
  </Box>

  {/* Est Pmt */}
  <Box sx={{ textAlign: 'center', width: 200 }}>
    <PaymentIcon fontSize="large" />
    <Typography>Est. Payment</Typography>
    <Typography variant="h6">
      {`$${(Math.round(M * 10) / 10).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`}
    </Typography>
  </Box>

  {/* Est Mgmt */}
  <Box sx={{ textAlign: 'center', width: 200 }}>
    <ManageAccountsIcon fontSize="large" />
    <Typography>Est Mgmt</Typography>
    <Typography variant="h6">
      {`$${(Math.round(fmr * 0.1 * 10) / 10).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`}
    </Typography>
  </Box>
</Box>}
            <div style={pillContainer3}>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", marginBottom:'30px' }}>
  
  
  
  
  {/* <button
    onClick={handleButtonClick}
    style={{
      backgroundColor: "#0074e4",
      color: "white",
      padding: "10px 20px",
      borderRadius: "5px",
      border: "none",
      cursor: "pointer",
      fontWeight: "bold",
    }}
    disabled={loading}
  >
    {loading ? "Loading..." : "Find Assessor Info"}
  </button> */}
  </div>

  {isZillow && zillowDescription && (
            <Box
              sx={{
                maxWidth: 1000,
                mx: "auto",
                bgcolor: "#f9f9f9",
                borderRadius: 2,
                p: 3,
                mt: 4,
                mb: 2,
                boxShadow: 1
              }}
            >
              <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold' }}>
                About this home
              </Typography>
              <Typography variant="body2" sx={{ lineHeight: 1.6, color: "black" }}>
                {zillowDescription}
              </Typography>
            </Box>
          )}

  {descriptionText && (
  <Box
    sx={{
      maxWidth: 1000,          // limit width
      mx: "auto",             // center horizontally
      bgcolor: "#f9f9f9",     // light background
      borderRadius: 2,        // rounded corners
      p: 3,                   // padding
      mt: 4,                  // space above
      mb: 2,                  // space below
      boxShadow: 1            // subtle shadow
    }}
  >
    <Typography
      variant="body1"
      sx={{ 
        textAlign: "center",   // ← center the text

        lineHeight: 1.6,
        color: "black"
      }}
    >
      {descriptionText}
    </Typography>
  </Box>
)}
{history.length > 0 && (
  <>
    {/* Price History Title */}
    <Box sx={{ px: 2, py: 3, textAlign: 'center' }}>
      <Typography 
        variant="h6" 
        align="center" 
        sx={{ fontWeight: 'bold' }} 
        gutterBottom
      >
        Price History
      </Typography>
    </Box>
    <div style={{ width: '100%', height: 300 }}>
      <ResponsiveContainer>
        <LineChart
          data={history
            .slice()
            .sort((a, b) => a.time - b.time)
            .map(h => ({ date: h.date, price: h.price ?? purchasePrice }))}
          margin={{ top: 20, right: 30, left: 0, bottom: 0 }}
        >
          <CartesianGrid strokeDasharray="3 3" />

          <XAxis
            dataKey="date"
            tickFormatter={iso => {
              const d = new Date(iso);
              const mm = String(d.getMonth() + 1).padStart(2, '0');
              const dd = String(d.getDate()).padStart(2, '0');
              const yy = String(d.getFullYear()).slice(-2);
              return `${mm}/${dd}/${yy}`;
            }}
            tick={{ fontSize: 12 }}
          />

          <YAxis
            tick={{ fontSize: 12 }}
            tickFormatter={v => `$${v}`}
          />

          <Tooltip
            formatter={v => [`$${v}`, 'Price']}
            labelFormatter={iso => {
              const d = new Date(iso);
              const mm = String(d.getMonth() + 1).padStart(2, '0');
              const dd = String(d.getDate()).padStart(2, '0');
              const yy = String(d.getFullYear()).slice(-2);
              return `${mm}/${dd}/${yy}`;
            }}
          />

          <Line
            type="monotone"
            dataKey="price"
            stroke="#8884d8"
            strokeWidth={2}
            dot={{ r: 3 }}
            activeDot={{ r: 6 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  </>
)}

{taxHistory.length > 0 && (
  <>
   <Box sx={{ px: 2, py: 3, textAlign: 'center' }}>
     <Typography 
       variant="h6" 
       align="center" 
       sx={{ fontWeight: 'bold' }} 
       gutterBottom
     >
       Tax History
     </Typography>
   </Box>
    <div style={{ width: '100%', height: 300 }}>
      <ResponsiveContainer>
        <LineChart
          data={taxHistory
            .slice()
            .sort((a, b) => a.year - b.year)
            .map(t => ({
              date: t.year.toString(),
              tax: t.tax_paid ?? t.tax ?? 0
            }))}
          margin={{ top: 20, right: 30, left: 0, bottom: 0 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" tick={{ fontSize: 12 }} />
          <YAxis tick={{ fontSize: 12 }} tickFormatter={v => `$${v}`} />
          <Tooltip formatter={v => `$${v}`} />
          <Line
            type="monotone"
            dataKey="tax"
            stroke="#82ca9d"
            strokeWidth={2}
            dot={{ r: 3 }}
            activeDot={{ r: 6 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  </>
)}
{similarProperties.length > 0 && (
  <Box sx={{ px: 2, py: 3 }}>
    <Typography variant="h6" gutterBottom>Similar Properties</Typography>
    <Box sx={{ display: 'flex', overflowX: 'auto', gap: 2, pb: 1 }}>
      {similarProperties.map((home) => {
        const {
          zpid,
          miniCardPhotos,
          address,
          bedrooms,
          bathrooms,
          price,
          livingArea,
          livingAreaUnits,
          homeStatus,
          listing_sub_type = {}
        } = home;

        // Determine status label
        let marketStatus = "Unknown";
        if (homeStatus === "SOLD" || homeStatus === "RECENTLY_SOLD") marketStatus = "Sold";
        else if (listing_sub_type.is_forRent || homeStatus === "FOR_RENT") marketStatus = "For Rent";
        else if (listing_sub_type.is_forSale || homeStatus === "FOR_SALE") marketStatus = "For Sale";
        else if (listing_sub_type.is_comingSoon) marketStatus = "Coming Soon";
        else if (listing_sub_type.is_pending) marketStatus = "Pending";
        else if (homeStatus === "OTHER") marketStatus = "Off Market";

        return (
          <Card
            key={zpid}
            onClick={() => handleNearbySelect(home)}
            sx={{
              minWidth: 260,
              border: '1px solid #eee',
              borderRadius: 2,
              cursor: 'pointer',
              flexShrink: 0,
              position: 'relative'
            }}
          >
            <CardMedia
              component="img"
              image={miniCardPhotos?.[0]?.url}
              alt={address?.streetAddress}
              sx={{ height: 140, objectFit: 'cover' }}
            />
            {/* Status badge */}
            <Box
              sx={{
                position: 'absolute',
                top: 8,
                right: 8,
                bgcolor: 'rgba(0,0,0,0.6)',
                color: '#fff',
                px: 1,
                py: 0.5,
                borderRadius: 1,
                fontSize: 12,
                fontWeight: 'bold'
              }}
            >
              {marketStatus}
            </Box>
            <CardContent sx={{ p: 1 }}>
              <Typography variant="body2" noWrap>
                {address?.streetAddress}
              </Typography>
              <Typography variant="caption" color="textSecondary">
                {bedrooms ?? '–'} bd • {bathrooms ?? '–'} ba
              </Typography>
              <Typography variant="subtitle2" sx={{ mt: 0.5 }}>
                {price != null ? `$${price.toLocaleString()}` : '–'}
              </Typography>
              {livingArea != null && (
                <Typography variant="caption" color="textSecondary" sx={{ mt: 0.5, display: 'block' }}>
                  {`${livingArea.toLocaleString()} ${livingAreaUnits}`}
                </Typography>
              )}
            </CardContent>
          </Card>
        );
      })}
    </Box>
  </Box>
)}
{similarSales.length > 0 && (
  <Box sx={{ px: 2, py: 3 }}>
    <Typography variant="h6" gutterBottom>Similar Sold Homes</Typography>
    <Box sx={{ display: 'flex', overflowX: 'auto', gap: 2, pb: 1 }}>
  {(similarSales ?? []).map(home => {
    const homeStatus = home.homeStatus;
    let marketStatus = "Unknown";
    if (homeStatus === "SOLD" || homeStatus === "RECENTLY_SOLD") marketStatus = "Sold";
    else if (homeStatus === "FOR_RENT") marketStatus = "For Rent";
    else if (homeStatus === "FOR_SALE") marketStatus = "For Sale";
    else if (homeStatus === "COMING_SOON") marketStatus = "Coming Soon";
    else if (homeStatus === "PENDING") marketStatus = "Pending";
    else if (homeStatus === "OTHER") marketStatus = "Off Market";

    return (
      <Card
        key={home.zpid}
        onClick={() => handleNearbySelect(home)} // or handleSimilarSelect(home)
        sx={{
          minWidth: 260,
          border: '1px solid #eee',
          borderRadius: 2,
          cursor: 'pointer',
          flexShrink: 0,
          position: 'relative'
        }}
      >
        <CardMedia
          component="img"
          image={home.miniCardPhotos?.[0]?.url}
          alt={home.address?.streetAddress}
          sx={{ height: 140, objectFit: 'cover' }}
        />
        {/* Status badge */}
        <Box
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            bgcolor: 'rgba(0,0,0,0.6)',
            color: '#fff',
            px: 1,
            py: 0.5,
            borderRadius: 1,
            fontSize: 12,
            fontWeight: 'bold'
          }}
        >
          {marketStatus}
        </Box>
        <CardContent sx={{ p: 1 }}>
          <Typography variant="body2" noWrap>
            {home.address?.streetAddress}
          </Typography>
          <Typography variant="caption" color="textSecondary">
            {home.bedrooms ?? '–'} bd • {home.bathrooms ?? '–'} ba
          </Typography>
          <Typography variant="subtitle2" sx={{ mt: 0.5 }}>
            {home.price != null ? `$${home.price.toLocaleString()}` : '–'}
          </Typography>
          {home.livingArea != null && (
            <Typography variant="caption" color="textSecondary" sx={{ mt: 0.5, display: 'block' }}>
              {`${home.livingArea.toLocaleString()} ${home.livingAreaUnits ?? 'sqft'}`}
            </Typography>
          )}
        </CardContent>
      </Card>
    );
  })}
</Box>
  </Box>
)}
{/* Nearby Homes */}
{/* Nearby Homes */}
{/* Nearby Homes */}
<Box sx={{ px: 2, py: 3 }}>
  {isZillow && <Typography variant="h6" gutterBottom>Nearby Homes</Typography>}
  <Box sx={{ display: 'flex', overflowX: 'auto', gap: 2, pb: 1 }}>
    {(listing.nearbyHomes ?? []).map(home => {
      const { homeStatus, listing_sub_type = {} } = home;
      let marketStatus = "Unknown";
      if (homeStatus === "SOLD") marketStatus = "Sold";
      else if (listing_sub_type.is_forRent || homeStatus === "FOR_RENT") marketStatus = "For Rent";
      else if (listing_sub_type.is_forSale || homeStatus === "FOR_SALE") marketStatus = "For Sale";
      else if (listing_sub_type.is_comingSoon) marketStatus = "Coming Soon";
      else if (listing_sub_type.is_pending) marketStatus = "Pending";
      else if (homeStatus === "OTHER") marketStatus = "Off Market";

      return (
        <Card
          key={home.zpid}
          onClick={() => handleNearbySelect(home)}
          sx={{
            minWidth: 260,
            border: '1px solid #eee',
            borderRadius: 2,
            cursor: 'pointer',
            flexShrink: 0,
            position: 'relative'
          }}
        >
          {/* Image */}
          <CardMedia
            component="img"
            image={home.miniCardPhotos?.[0]?.url}
            alt={home.address.streetAddress}
            sx={{ height: 140, objectFit: 'cover' }}
          />
          {/* Status overlay */}
          <Box
            sx={{
              position: 'absolute',
              top: 8,
              right: 8,
              bgcolor: 'rgba(0,0,0,0.6)',
              color: '#fff',
              px: 1,
              py: 0.5,
              borderRadius: 1,
              fontSize: 12,
              fontWeight: 'bold'
            }}
          >
            {marketStatus}
          </Box>
          {/* Details */}
          <CardContent sx={{ p: 1 }}>
            <Typography variant="body2" noWrap>
              {home.address.streetAddress}
            </Typography>
            <Typography variant="caption" color="textSecondary">
              {home.bedrooms ?? '–'} bd • {home.bathrooms ?? '–'} ba
            </Typography>
            <Typography variant="subtitle2" sx={{ mt: 0.5 }}>
              {home.price != null ? `$${home.price.toLocaleString()}` : '–'}
            </Typography>
            {home.livingAreaValue != null && (
              <Typography variant="caption" color="textSecondary" sx={{ mt: 0.5, display: 'block' }}>
                {`${home.livingAreaValue.toLocaleString()} ${home.livingAreaUnitsShort || home.livingAreaUnits}`}
              </Typography>
            )}
          </CardContent>
        </Card>
      );
    })}
  </Box>
</Box>
{/* Nearby Homes Map */}
{/* Nearby Homes Map */}
{listing.latitude && listing.nearbyHomes?.length > 0 && (
  <Box sx={{ px: 2, pt: 1, pb:5 }}>
    {/* <Typography variant="h6" gutterBottom>
      Nearby Homes (Map)
    </Typography> */}
    <MapContainer
      center={[listing.latitude, listing.longitude]}
      zoom={13}
      style={{ height: 300, width: '100%', borderRadius: 8 }}
      scrollWheelZoom={false}
    >
      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

      {/* fit map to show all nearby homes */}
      <FitBounds homes={listing.nearbyHomes} />

      {listing.nearbyHomes.map(home => (
        <Marker
          key={home.zpid}
          position={[home.latitude, home.longitude]}
          icon={createMarkerIcon(home)}
          eventHandlers={{
            click: () => handleNearbySelect(home)
          }}
        />
      ))}
    </MapContainer>
  </Box>
)}








                <div>
                        <div style={{
                            textAlign: 'center',
                            border:'2px solid',
                            borderRadius:'30px',
                            width: '400px',
                            marginLeft:'55px',
                            float:'left',
                            padding:'5px'
                        }}>
                            <b>Listing Agent </b>
                            <div style={{marginBottom:3}}>
                            <PersonOutlineIcon style={{marginTop:-3}}/> {agentName ?? "—"}
                        </div>
                            <div>
                            <PhoneAndroidIcon style={{marginBottom:3}}/>    {agentPhone ?? "—"}<br />

                        </div>
                            <div>
                            <EmailIcon style={{marginBottom:3}}/>     {agentEmail ?? "—"}

                        </div>
                            
                        </div>
                        
                </div>
                
                <div>
                        <div style={{
                            textAlign: 'center',
                            border:'2px solid',
                            borderRadius:'30px',
                            width: '400px',
                            float:'left',
                            padding:'5px',
                            marginLeft:'124px'
                        }}>
<b>Listing Office </b>                            <div>
<BusinessIcon style={{marginBottom:3}}/>     {officeName ?? "—"}<br />

                        </div>
                            <div>
                            <PhoneAndroidIcon style={{marginBottom:3}}/>     {officePhone ?? "—"}<br />

                        </div>
                            <div>
                            <EmailIcon style={{marginBottom:3}}/>    {officeEmail ?? "—"}

                        </div>
                            
                        </div>
                        
                </div>
                <div>

            
             </div>

             
            <div>
              
            <p style={{ marginTop: "1rem" }}>
            
            </p>
            
         
            <p style={{ marginTop: "1rem" }}>


            
            </p>
            <p style={{ marginTop: "1rem" }}>


            
  </p>
            </div>
            </div>
  
            
            
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
        <Grid item xs={6} align={'center'}>
            <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ fontWeight: 'bold', alignContent:'center'}}>
            Current Financials
            
          </Typography>
            </Grid>
            <Grid item xs={6} align={'center'}>
            <Typography id="modal-modal-title" sx={{ fontWeight: 'bold'}} variant="h6" component="h2">
            Cashflow Calculation
           
          </Typography>
          
            </Grid>
            </Grid>
            <Grid container columns={2} >  
            <Grid container columns={2} xs={1} sx={{ border: 1, borderRadius:'5px', marginTop:'10px', padding:2}}>
            <Grid item xs={1}>
            <Typography id="modal-modal-title"  variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Prop Mgmt</h3>
              <h3 align="center">{`$${Math.round(fmr * 0.1).toLocaleString('en-US')}`}</h3>
              {/* <h3 align={'center'}>$100</h3> */}
  
          </Typography>
            <Typography 
              id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Prop Taxes</h3>
              <h3 align="center">{`$${Math.round(purchasePrice * 0.000925).toLocaleString('en-US')}`}</h3>

          </Typography>
            </Grid>
            <Grid item xs={1} sx={{borderBottom:'1px'}}>
            <Typography  id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}} >Gross Rent</h3>
              <h3 align="center">{`$${Number(fmr).toLocaleString('en-US')}`}</h3>
              {/* <h3 align={'center'} style={{fontWeight:'bold'}}>Prop Taxes</h3>
              <h3 align={'center'}>${(purchasePrice * .000925)}</h3> */}
              
          </Typography>
            <Typography  id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Total Op. Expenses</h3>
              <div align="center">
  {`$${Number(
    (
      potentialTotalPropManagement +
      propertyTaxOperatingCost +
      insuranceOperatingCost +
      monthlyUtilities +
      monthlyVacancyReserve +
      monthlyMaintainenceReservation
    ).toFixed(2)
  ).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
</div>
          </Typography>
            </Grid>
            <Grid item xs={1}>
            <Typography  id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Insurance</h3>
              <h3 align="center">
  {`$${Math.round(purchasePrice * 0.000833).toLocaleString('en-US')}`}
</h3>              
          </Typography>
            <Typography id="modal-modal-title" variant="h6" component="h2" >
            <h3 align={'center'} style={{fontWeight:'bold'}}>Utilities</h3>
              <NumberInput aria-label="Quantity Input"  style={{marginBottom:'10px'}} min={1} max={100000}   value={monthlyUtilities}
    onChange={(event, val) => setMonthlyUtilities(val)}/>
          </Typography>
            </Grid>

            <Grid item xs={1}>
            <Typography  id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Monthly NOI</h3>
              <div align="center">
  {`$${Number(
    fmr -
      (potentialTotalPropManagement +
        propertyTaxOperatingCost +
        insuranceOperatingCost +
        monthlyUtilities +
        monthlyVacancyReserve +
        monthlyMaintainenceReservation)
  ).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
</div>              {/* <div align={'center'} >$ </div> */}
              
          </Typography>
            <Typography id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Annual NOI</h3>
              <div align="center">
  {`$${Math.round(
    (fmr -
      (potentialTotalPropManagement +
        propertyTaxOperatingCost +
        insuranceOperatingCost +
        monthlyUtilities +
        monthlyVacancyReserve +
        monthlyMaintainenceReservation)) *
      12
  ).toLocaleString('en-US')}`}
</div>
          </Typography>
            </Grid>
            <Grid item xs={1}>
            <Typography  id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Vacancy Reserve</h3>
              <NumberInput style={{marginBottom:'10px'}}aria-label="Quantity Input" min={1} max={100000}   value={monthlyVacancyReserve}
    onChange={(event, val) => setMonthlyVacancyReserve(val)}

/>              
          </Typography>
            <Typography id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Mtc Reserve</h3>
              <NumberInput style={{marginBottom:'10px'}} aria-label="Quantity Input" min={1} max={100000}   value={monthlyMaintainenceReservation}
    onChange={(event, val) => setMonthlyMaintainenceReservation(val)}

/>
          </Typography>
            </Grid>
            <Grid item xs={1}>
            <Typography  id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Cap Rate</h3>
              <div align="center">
  {`${Number(
    ((fmr -
      (potentialTotalPropManagement +
        propertyTaxOperatingCost +
        insuranceOperatingCost +
        monthlyUtilities +
        monthlyVacancyReserve +
        monthlyMaintainenceReservation)) *
      12) /
      purchasePrice *
      100,
  ).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%`}
</div>
          </Typography>
            <Typography id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold', marginTop:'16px'}}>Mortgage</h3>
              {/* <div align={'center'} >${Math.round(monthlyPayment(P,N,I))}</div> */}
              <div align="center">
  {`$${Math.round(M).toLocaleString('en-US')}`}
</div>

          </Typography>
            <Typography id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold', marginTop:'16px'}}>Monthly Cashflow</h3>
              <div align="center">
  {`$${Math.round(fmr - potentialTotalMonthlyExpense).toLocaleString('en-US')}`}
</div>
          </Typography>
            <Typography id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold', marginTop:'16px'}}>Annual Cashflow</h3>
              {/* <div align={'center'} >${(currentRent - totalMonthlyExpense)*12}</div> */}
              <div align="center">
  {`$${Math.round((fmr - potentialTotalMonthlyExpense) * 12).toLocaleString('en-US')}`}
</div>
          </Typography>
            <Typography id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold', marginTop:'16px'}}>Annualized ROI</h3>
              <div align="center">
  {`${Number(
    100 * (((fmr - potentialTotalMonthlyExpense) * 12) / purchasePrice),
  ).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%`}
</div>
          </Typography>







            </Grid>
            </Grid>
            <Grid container columns={2} xs={1} sx={{ border: 1, borderRadius:'5px', marginTop:'10px', padding:2, marginLeft:'0px'}}>
  
  <Grid item xs={1}>
            <Typography id="modal-modal-title"  variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}} >Down Payment %</h3>
              <NumberInput style={{marginBottom:'10px'}}aria-label="Quantity Input" min={1} max={100000}   value={downPaymentPercentage}
    onChange={(event, val) => setDownPaymentPercentage(val)}

/>              
  
          </Typography>
            <Typography 
              id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Closing Cost %</h3>
              <NumberInput style={{marginBottom:'10px'}}aria-label="Quantity Input" min={1} max={100000}   value={closingCostsPercentage}
    onChange={(event, val) => setClosingCostsPercentage(val)}

/>              

          </Typography>
            
            </Grid>
            <Grid item xs={1} sx={{borderBottom:'1px'}}>
            <Typography  id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}} >Down Payment</h3>
              <h3 align="center">
  {`$${Math.round(purchasePrice * (downPaymentPercentage * 0.01)).toLocaleString('en-US')}`}
</h3>             
              
          </Typography>
            <Typography  id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold', marginTop:'14px'}}>Closing Costs</h3>
              <div align="center">
  {`$${Math.round(purchasePrice * (closingCostsPercentage * 0.01)).toLocaleString('en-US')}`}
</div>              {/* <h3 align={'center'}>$</h3> */}

          </Typography>
            </Grid>
            <Grid item xs={1}>
            <Typography  id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Interest Rate %</h3>
              <NumberInput style={{marginBottom:'10px'}}aria-label="Quantity Input" min={1} max={100000}   value={interestRate}
    onChange={(event, val) => setInterestRate(val)}

/>              
              
          </Typography>
            <Typography id="modal-modal-title" variant="h6" component="h2" >
            <h3 align={'center'} style={{fontWeight:'bold'}}>Purchase Price</h3>
            {/* <h3 align={'center'}>${listing.price }</h3> */}
            <NumberInput style={{marginBottom:'10px'}}aria-label="Quantity Input" min={1} max={100000}   value={purchasePrice}
    onChange={(event, val) => setPurchasePrice(val)} />


          </Typography>
            </Grid>

            <Grid item xs={1}>
            <Typography  id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Term (yrs)</h3>
              {/* <div align={'center'} >${marketRent - (potentialTotalPropManagement+propertyTaxOperatingCost+insuranceOperatingCost+monthlyUtilities+monthlyVacancyReserve+monthlyMaintainenceReservation) }</div> */}
              <NumberInput style={{marginBottom:'10px'}}aria-label="Quantity Input" min={1} max={100000}   value={term}
    onChange={(event, val) => setTerm(val)}

/>             

          </Typography>
            <Typography id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>LTV</h3>
              {/* <div align={'center'} >${(marketRent - (potentialTotalPropManagement+propertyTaxOperatingCost+insuranceOperatingCost+monthlyUtilities+monthlyVacancyReserve+monthlyMaintainenceReservation))*12}</div> */}
              <h3 align={'center'}>{100-downPaymentPercentage}%</h3>

          </Typography>
            </Grid>
<Grid item xs={1}>
            <Typography  id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Principal</h3>
              <h3 align="center">
  {`$${Number(
    purchasePrice - Math.round(purchasePrice * (downPaymentPercentage * 0.01))
  ).toLocaleString('en-US')}`}
</h3>
              
          </Typography>
           
            </Grid>
            <Grid item xs={1}>
            <Typography  id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Mortgage Payment</h3>
              <h3 align="center">
  {`$${Number(calculatedM).toLocaleString('en-US')}`}
</h3>              
          </Typography>
            
          <Typography id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold', marginTop:'16px'}}>Monthly Cashflow</h3>
              <div align="center">
  {`$${Math.round(fmr - potentialTotalMonthlyExpense).toLocaleString('en-US')}`}
</div>
          </Typography>
            <Typography id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold', marginTop:'16px'}}>Annual Cashflow</h3>
              {/* <div align={'center'} >${(currentRent - totalMonthlyExpense)*12}</div> */}
              <div align="center">
  {`$${Math.round((fmr - potentialTotalMonthlyExpense) * 12).toLocaleString('en-US')}`}
</div>
          </Typography>
            <Typography id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold', marginTop:'16px'}}>Annualized ROI</h3>
              <div align={'center'} >{(100*(((fmr - potentialTotalMonthlyExpense)*12)/purchasePrice)).toFixed(2)}%</div>

          </Typography>
            </Grid>






            </Grid>

</Grid>

            
          </div>
         
        </div>
        </Card>

          {/* Add other listing details as needed */}
          {/* {/* <button onClick={onClose}>Close</button> */}
          <div style={{  marginTop: 20, marginRight: 0, display: 'flex' , justifyContent:'center'}} >

          <button onClick={onClose} class="bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded">
  Close
</button>
</div>
        </div>
      
    );
  };
  
  export default OfferModal

